import styled from "styled-components";
import Spring from "../../components/Spring";


export const StyledClosingClassroom = styled.div`
    padding-top: 16px;
    padding-bottom: 16px;
    min-height: calc(100vh - 50px);
    text-align: center;
`;

export const StyledSpring = styled(Spring)`
    margin-top: 50px;
    background-color: ${p => p.theme.c.snow};
`;
